import navigation from "@/pages/global/components/nav-bar/nav-bar.vue";
import bottom from "@/pages/global/components/bottom-bar/bottom-bar.vue";

export default {
    name: 'ProfilePassword',
    components: {
        navigation,
        bottom
    },
};



// WEBPACK FOOTER //
// ./src/pages/dashboard/partials/dashboard-password/dashboard-password.js